<template>
        <v-progress-circular
                :rotate="360"
                :size="70"
                :width="15"
                :value="total_progress"
                color="teal">
            {{total_progress}}
        </v-progress-circular>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    export default {
        name: 'miniProgressCourse',
        props: ['id'],
        components: {

        },
        created(){
            this.getUserProgress();
        },
        data(){
            return {
                total_progress:'20'
            }
        },
        computed: {
            ...mapState,
            ...mapGetters([
                'progress_total'
            ]),
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },

        },
        methods:{
            getUserProgress: function () {
                var url = '/api/v1/getUserProgress';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    mounted_course_id  : this.id,
                    userId    : this.userId.id,

                }).then(response => {
                    //this.progress=response.data;

                    var total= 0;

                    var progress = response.data;
                    Object.keys(progress).forEach(function (key) {
                        total = total + Number(progress[key].value)
                        
                    });
                    if(total > 100){
                        total = 100;
                    }
                    this.total_progress = total.toFixed(0);
                    /*this.$store.commit('total_progress', total.toFixed(0));*/
                })
            }
        }

    }
</script>
